import { useEditor, Editor } from "@tiptap/react";
import { createEditorExtensions } from "../components/editor/extensions";
import { EditorHookOptions } from "../types/editor";

export const useTiptapEditor = ({
  initialContent = "",
  onChange,
  placeholder = "Start writing your report...",
  editable = true,
}: EditorHookOptions = {}): Editor | null => {
  const editor = useEditor({
    extensions: createEditorExtensions(placeholder),
    content: initialContent,
    editorProps: {
      attributes: {
        class:
          "tiptap-editor prose prose-sm sm:prose lg:prose-lg xl:prose-2xl mx-auto focus:outline-none",
      },
    },
    onUpdate: ({ editor }: { editor: Editor }) => {
      if (onChange) {
        onChange(editor.getHTML());
      }
    },
    editable: editable,
  });

  return editor;
};
